<template>
  <v-container grid-list-md fluid align-start >
    <v-layout align-center justify-space-around wrap>
      <v-flex md6>
        <v-card >
          <v-list dense>
            <v-list-tile>
              <v-list-tile-content>Error:</v-list-tile-content>
              <v-list-tile-content class="align-end">{{ this.$route.params.message }}</v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>Debug:</v-list-tile-content>
              <v-list-tile-content class="align-end">{{ this.$route.params.error }}</v-list-tile-content>
            </v-list-tile>
            </v-list>
            <v-divider></v-divider>
            <v-btn
              flat
              @click.prevent="openHomePage()"
            >
              <v-icon dark left>keyboard_arrow_left</v-icon> Back
            </v-btn>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    openHomePage() {
      this.$router.push({ name: 'home-page' });
    },
  },
  beforeDestroy() {
  }
}
</script>
